import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Sparkles, Microscope } from 'lucide-react';
export function RevelationSection() {
  return <section className="py-14 md:py-24 px-6 bg-sage/10 relative overflow-hidden" data-id="element-137">
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10 opacity-30" data-id="element-138">
        <div className="absolute -top-40 -right-40 w-96 h-96 rounded-full bg-sage/20 blur-3xl" data-id="element-139"></div>
        <div className="absolute bottom-0 -left-20 w-72 h-72 rounded-full bg-gold/10 blur-3xl" data-id="element-140"></div>
      </div>

      <div className="max-w-4xl mx-auto" data-id="element-141">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} data-id="element-142">
          <div className="text-center mb-10 md:mb-16" data-id="element-143">
            <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-144">
              La Verdad Que Ocultan Las Grandes Marcas
            </h2>
            <p className="text-xl text-charcoal/80 max-w-2xl mx-auto" data-id="element-145">
              La piel no lee etiquetas de precios,{' '}
              <span className="font-bold text-gold" data-id="element-146">lee moléculas.</span>
            </p>
          </div>

          <div className="bg-white p-6 md:p-12 rounded-2xl shadow-xl border border-sage/20 mb-8 md:mb-12" data-id="element-147">
            <div className="flex flex-col md:flex-row gap-8 items-center" data-id="element-148">
              <div className="md:w-1/3 flex justify-center" data-id="element-149">
                <div className="w-32 h-32 rounded-full bg-cream flex items-center justify-center border-4 border-sage/30" data-id="element-150">
                  <Microscope className="w-16 h-16 text-sage" data-id="element-151" />
                </div>
              </div>
              <div className="md:w-2/3 space-y-4" data-id="element-152">
                <h3 className="text-2xl font-bold font-serif text-charcoal" data-id="element-153">
                  El Estudio de 2025
                </h3>
                <p className="text-lg text-charcoal/70 leading-relaxed" data-id="element-154">
                  Un estudio reciente confirma que el{' '}
                  <strong className="text-charcoal bg-gold/20 px-2 py-1 rounded" data-id="element-155">
                    85% de los ingredientes
                  </strong>{' '}
                  en cremas de lujo son rellenos, fragancias y conservantes que
                  no aportan nada a tu regeneración celular.
                </p>
              </div>
            </div>
          </div>

          <div className="space-y-6 md:space-y-8" data-id="element-156">
            <h3 className="text-2xl md:text-3xl font-bold text-center mb-6 md:mb-10" data-id="element-157">
              La Solución: Skin-Cycling Estratégico
            </h3>

            <div className="grid md:grid-cols-2 gap-6" data-id="element-158">
              <div className="flex gap-4 items-start" data-id="element-159">
                <div className="mt-1 bg-gold/20 p-2 rounded-full" data-id="element-160">
                  <Sparkles className="w-6 h-6 text-gold" data-id="element-161" />
                </div>
                <div data-id="element-162">
                  <h4 className="font-bold text-lg mb-2" data-id="element-163">Activos Potentes</h4>
                  <p className="text-charcoal/70" data-id="element-164">
                    Alternar noches de activos potentes de farmacia para
                    estimular la renovación celular.
                  </p>
                </div>
              </div>

              <div className="flex gap-4 items-start" data-id="element-165">
                <div className="mt-1 bg-sage/20 p-2 rounded-full" data-id="element-166">
                  <ShieldCheck className="w-6 h-6 text-sage" data-id="element-167" />
                </div>
                <div data-id="element-168">
                  <h4 className="font-bold text-lg mb-2" data-id="element-169">
                    Recuperación Profunda
                  </h4>
                  <p className="text-charcoal/70" data-id="element-170">
                    Noches dedicadas exclusivamente a reparar la barrera cutánea
                    y producir colágeno sin inflamarse.
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-8 md:mt-12 text-center" data-id="element-171">
              <p className="text-xl font-serif italic text-charcoal/90 border-b border-gold/30 inline-block pb-2" data-id="element-172">
                Es ciencia pura, aplicada con precios de genérico.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}